module.exports = __webpack_public_path__ + "static/img/20010 (3).0f9d2e0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20010 (3).webp
// module id = NDN8
// module chunks = 14